<template>
  <div class="files-list">
    <div class="files-list__item" v-for="(file, index) in files" :key="file.id">
      <p class="w-3 t-c">{{ index + 1 }}.</p>
      <a :href="file.file_path" class="w-50" target="_blank">{{ file.name }}</a>

      <svg @click="openModal(file.id)" class="files-list__item-img">
        <use xlink:href="/images/svg/symbols.svg#svg-user-del"></use>
      </svg>
    </div>

    <modal
      :show="isShowModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        @cancel="closeModal"
        @next="deleteFile"
      />
    </modal>
  </div>
</template>

<script>
export default {
    name: 'fileslist',
    props: {
        files: {
            required: true,
        },
    },
    data() {
        return {
            isShowModal: false,
            fileId: null,
        }
    },
    methods: {
        openModal(id) {
            this.fileId = id
            this.isShowModal = true
        },
        closeModal() {
            this.isShowModal = false
        },
        deleteFile() {
            this.closeModal()
            this.$emit('remove', this.fileId)
        },
    },
}
</script>

<style lang="scss" scoped>
.files-list {
  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: var(--menu-text-color);

    &-img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
